import React from 'react';
import './Real.css'; // create this stylesheet

function Real() {
  return (
<div className="announce-container">
      <h1>Any animosity that I've ever had towards anyone is gone. I feel peace and love (in Arlo's words) towards everyone. Should I go home rn? 
 </h1>
      </div>
  );
}

export default Real;
